import styled, { keyframes } from "styled-components";
import arrows from "./slider-arrows.svg";

export const shadowPulse = (color) => keyframes`
  0% {
    box-shadow: 0 0 0 0px ${color};
  }
  100% {
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
`;

export const AhpContainer = styled.div`
  margin: 0 auto;
  text-align: center;
  clear: both;
  width: 250px;
  position: relative;
  display: flex;
`;

export const Option = styled.div`
  background: #65e0d4;
  background-color: ${(props) => props.theme.themeGlobal.ahpColorRight};
  display: inline-block;
  width: ${(props) => (props.width < 10 ? 5 : props.width)}%;
  padding: 10px;
  border-radius: 0 30px 30px 0;
  border-left: 1px solid #fff;
  white-space: nowrap;
  font-size: 12px;
  text-transform: uppercase;
  position: relative;
  &.left {
    background: #ebe45b;
    background-color: ${(props) => props.theme.themeGlobal.ahpColorLeft};
    border-radius: 30px 0 0 30px;
    border-right: 1px solid #fff;
  }
`;

export const Thumb = styled.div`
  position: absolute;
  right: -16px;
  z-index: 10;
  top: 2px;
  border-radius: 50%;
  background-color: white;
  background-image: url(${arrows});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  width: 30px;
  height: 30px;
  margin-left: -15px;
  cursor: pointer;
  animation: ${(props) => shadowPulse(props.theme.themeGlobal.positive)} 1.5s infinite;
`;

export const Legend = styled.div`
  width: 250px;
  margin: 5px auto;
  font-size: 10px;
  p:first-child {
    text-align: left;
  }
  p {
    display: inline-block;
    width: 33%;
    font-size: 12px;
    overflow: hidden;
    text-align: right;
  }
`;

export const ButtonSend = styled.button`
  background-color: ${(props) => props.theme.themeGlobal.dbotAnswerColor};
  color: white;
  font-size: 12px;
  border-radius: 8px;
  padding: 8px 10px;
  margin-top: 10px;
  width: 250px;
`;
